import {
    STOCK_BALANCE_ASIDE_RECEIVE
} from '../constants';

const DEFAULT_STATE = {
    result: null
};

export const storeStockBalance = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case STOCK_BALANCE_ASIDE_RECEIVE:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
